import { API } from "config";
import request from "utilities/request";

const baseUrl = API.cortevaChain.url;

export interface ChatAccessResponse {
  enforced: boolean;
  /** Null when the API couldn't check membership. */
  member: boolean | null;
}

/**
 * Asks the chat API whether the user is in the chat group. When access is
 * enforced, a non-member gets a 403 and a failed check gets a 503.
 */
export async function getChatAccess(
  getAccessToken: () => Promise<string>
): Promise<ChatAccessResponse> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/chat/access`;
  const headers = { Authorization: `Bearer ${accessToken}` };
  const options = { method: "GET", headers };

  const response = await request(url, options);
  return (await response.json()) as ChatAccessResponse;
}
